import { render, staticRenderFns } from "./LeaderDeptRecieve.vue?vue&type=template&id=480acf5a&"
import script from "./LeaderDeptRecieve.vue?vue&type=script&lang=js&"
export * from "./LeaderDeptRecieve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports